import React from 'react';
import PropTypes from 'prop-types';

const AMIMeteringSection = ({ image, title, subtitle, description1, description2 }) => {
  return (
    <section className="py-8 md:py-12 lg:py-16">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-bold mb-4 md:mb-5">
            <span className="">{title.split(' with ')[0]}</span> <span className="secondary-text">with {title.split(' with ')[1]}</span>
          </h2>
          <p className="   max-w-4xl mx-auto">
            {subtitle}
          </p>
        </div>

        {/* Content Box */}
        <div className="relative primary-bg rounded-3xl overflow-hidden shadow-2xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 items-stretch">
            {/* Left Side - Image with rounded top-left corner visible */}
            <div className="relative h-56 md:h-64 lg:h-72 order-1 lg:order-1">
              <img
                src={image}
                alt="Advanced Metering Infrastructure control room"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Right Side - Content with Primary Background */}
            <div className="p-6 md:p-8 lg:p-10 flex text-align-right order-2 lg:order-2">
              <div className="text-white text-right space-y-3 md:space-y-4">
                <p className="  leading-relaxed">
                  {description1}
                </p>
                <p className="  leading-relaxed">
                  {description2}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

AMIMeteringSection.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  description1: PropTypes.string.isRequired,
  description2: PropTypes.string.isRequired,
};

export default AMIMeteringSection;